import { CSmartTable } from '@coreui/react-pro'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import PlayerService from 'src/service/PlayerService'
import PlayerStatTable from './PlayerStatTable'
import ClubService from 'src/service/ClubService'

const PlayerStats = () => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(50)
  const [users, setUsers] = useState({})
  const columns = [
    {
      label: 'Player Name',
      filter: true,
      sorter: true,
      key: 'player_name',
      _props: { color: 'dark' },
    },
    { label: 'POS', filter: false, sorter: true, key: 'position_name', _props: { color: 'dark' } },
    { label: 'GO', filter: false, sorter: true, key: 'sum_go', _props: { color: 'dark' } },
    { label: 'GKS', filter: false, sorter: true, key: 'sum_gks', _props: { color: 'dark' } },
    { label: 'OG', filter: false, sorter: true, key: 'sum_og', _props: { color: 'dark' } },
    { label: 'AST', filter: false, sorter: true, key: 'sum_ast', _props: { color: 'dark' } },
    { label: 'PI', filter: false, sorter: true, key: 'sum_pi', _props: { color: 'dark' } },
    { label: 'PW', filter: false, sorter: true, key: 'sum_tw', _props: { color: 'dark' } },
    { label: 'PS', filter: false, sorter: true, key: 'sum_ps', _props: { color: 'dark' } },
    { label: 'PM', filter: false, sorter: true, key: 'sum_pm', _props: { color: 'dark' } },
    { label: 'GCD', filter: false, sorter: true, key: 'sum_gcd', _props: { color: 'dark' } },
    { label: 'YCD', filter: false, sorter: true, key: 'sum_ycd', _props: { color: 'dark' } },
    { label: 'RCD', filter: false, sorter: true, key: 'sum_rcd', _props: { color: 'dark' } },
    { label: 'CST', filter: false, sorter: true, key: 'sum_cst', _props: { color: 'dark' } },
    { label: 'P60', filter: false, sorter: true, key: 'sum_p60', _props: { color: 'dark' } },
    {
      label: 'P60PLUS',
      filter: false,
      sorter: true,
      key: 'sum_p60plus',
      _props: { color: 'dark' },
    },
    { label: 'FP', filter: false, sorter: true, key: 'sum_fp', _props: { color: 'dark' } },
  ]

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    PlayerService.playerStats(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  const [playerList, setPlayerList] = useState([])
  const [gameDetails, setGameDetails] = useState({})
  useEffect(() => {
    const fetchGameAndPlayerData = async () => {
      try {
        setLoading(true)

        const [clubDetailsResponse, playerResponse] = await Promise.all([
          ClubService.getClubDetails(),
          PlayerService.getAllPlayer(),
        ])

        if (clubDetailsResponse) {
          setGameDetails(clubDetailsResponse.game_details)
        }

        if (playerResponse?.status === 200) {
          setPlayerList(playerResponse.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchGameAndPlayerData()
  }, [])
  return (
    <>
      <PlayerStatTable
        users={users}
        activePage={activePage}
        setActivePage={setActivePage}
        columnFilter={columnFilter}
        setColumnFilter={setColumnFilter}
        columnSorter={columnSorter}
        setColumnSorter={setColumnSorter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        columns={columns}
        fetchData={fetchData}
        setLoading={setLoading}
        loading={loading}
        playerList={playerList}
      />
    </>
  )
}

export default PlayerStats
